import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { useFeatures } from '../../hooks/useFeatures';
import HeroTitle from './component';

const HeroTitleContainer = ({ title, prize }) => {
    const { features } = useFeatures();
    const isGoldCup = get(features, 'is_gold_cup', false);

    return <HeroTitle title={title} prize={prize} isGoldCup={isGoldCup} />;
};

HeroTitleContainer.propTypes = {
    title: PropTypes.string.isRequired,
    prize: PropTypes.string.isRequired
};

export default HeroTitleContainer;
